export default __webpack_public_path__ + "static/media/tick-icon-web.fae7b0f8.svg";